import ModalResult from '@/services/modals/ModalResult'
import ModalParams from '@/services/modals/ModalParams'

class ModalService {
  private showModalFunction!: <T>(modalParams: ModalParams<T>) => Promise<ModalResult<T>>

  public showModal<T>(modalParams: ModalParams<T>): Promise<ModalResult<T>> {
    return this.showModalFunction(modalParams)
  }

  public registerModalComponent(fn: (modalParams: ModalParams<unknown>) => Promise<ModalResult<unknown>>): void {
    this.showModalFunction = fn as never
  }
}

export const modalService = new ModalService()
